import FullWidthLayout from "@/layouts/FullWidthLayout";
import KTruckPreTripForm from "kinnect-front/KYard/Trucks/KTruckPreTripForm";
import { FetchesData, Pageable } from "kinnect-mixins";
import { getPreTrip } from "@/utils/http-calls";

export default {
	name: "YardTruckPreTripPage",

	metaInfo() {
		const title = this.viewing
			? "Yard - Trucks - View Pre-Trip"
			: "Yard - Trucks - Add a Pre-Trip";

		return { title };
	},

	props: {
		idTruck: {
			required: true,
			type: Number
		},

		idPreTrip: Number
	},

	mixins: [
		FetchesData,
		Pageable
	],

	data: () => ( {
		preTrip: null
	} ),

	computed: {
		viewing() {
			return Boolean( this.idPreTrip );
		}
	},

	methods: {
		async fetchPreTrip() {
			if ( this.viewing ) {
				this.preTrip = await getPreTrip( this.idTruck, this.idPreTrip );
			}
		},

		async fetch() {
			await this.fetchPreTrip();
		}
	},

	render() {
		if ( !this.fetched ) {
			return;
		}

		return <FullWidthLayout>
			<KTruckPreTripForm
				idTruck={this.idTruck}
				preTrip={this.preTrip}
			></KTruckPreTripForm>
		</FullWidthLayout>;
	}
};
